import * as React from 'react';
import { INavigateToPageConfig, PageComponentId } from '@wix/business-manager-api';
import { TabsSubtitle } from '@src/components/tabs-page/tabs-subtitle/tabs-subtitle';

export enum PageRoute {
  ROOT = '/',
  BANNER_SETTINGS = '/banner-settings',
  DATA_REQUEST = '/data-request',
  CONSENT_LOG = '/consent-log',
  ADVANCED_OPTIONS = '/banner-settings/advanced-options',
}

export interface IPage {
  route: string;
  hasSaveAction: boolean;
  titleKey?: string;
  subtitleComponent?: React.ReactElement;
  navigateConfig: INavigateToPageConfig;
}

export type IPages = {
  [key in PageRoute]: IPage;
};

export const Pages: IPages = {
  [PageRoute.ROOT]: {
    route: PageRoute.ROOT,
    titleKey: 'root.page.title',
    subtitleComponent: <TabsSubtitle />,
    hasSaveAction: false,
    navigateConfig: {
      pageComponentId: PageComponentId.CookieConsentBannerSettings,
    },
  },
  [PageRoute.BANNER_SETTINGS]: {
    route: PageRoute.BANNER_SETTINGS,
    titleKey: 'cookie.consent.banner',
    hasSaveAction: true,
    navigateConfig: {
      pageComponentId: PageComponentId.CookieConsentBannerSettings,
      contextData: {
        appState: 'banner-settings',
      },
    },
  },
  [PageRoute.ADVANCED_OPTIONS]: {
    route: PageRoute.ADVANCED_OPTIONS,
    titleKey: 'advanced.options',
    hasSaveAction: true,
    navigateConfig: {
      pageComponentId: PageComponentId.CookieConsentBannerSettings,
      contextData: {
        appState: 'banner-settings/advanced-options',
      },
    },
  },
  [PageRoute.DATA_REQUEST]: {
    route: PageRoute.DATA_REQUEST,
    hasSaveAction: false,
    navigateConfig: {
      pageComponentId: PageComponentId.Contacts,
      contextData: {
        appState: 'gdpr',
      },
    },
  },
  [PageRoute.CONSENT_LOG]: {
    route: PageRoute.CONSENT_LOG,
    hasSaveAction: false,
    navigateConfig: {
      pageComponentId: PageComponentId.CookieConsentBannerSettings,
      contextData: {
        appState: 'consent-log',
      },
    },
  },
};
